/**
 * @component Text
 * @description 감싸는 엘리먼트 없이 최종 콘텐츠 문구를 출력합니다.
 * @usage <Text contentKey="company.ceo.letter.lead" />
 */

import { useContent } from './useContent';

// [기능] 키의 최종 문구를 텍스트로 출력하며 빈 문자열은 노드를 만들지 않습니다.
export default function Text({ contentKey }) {
  // [비즈니스] 추가 span은 직접 자식 선택자와 grid 간격을 바꾸므로 허용하지 않습니다.
  // [기술] Fragment만 반환해 엘리먼트 노드를 만들지 않고 HTML과 개행도 텍스트로 유지합니다.
  return <>{useContent(contentKey)}</>;
}
